// extracted by mini-css-extract-plugin
export default {"wrapper":"whitelist_wrapper__-jJxJ","items":"whitelist_items__dV1OZ","item":"whitelist_item__2S7q3","deleteConfirmationModalFooter":"whitelist_deleteConfirmationModalFooter__H+01C"};